<astrobin-equipment-item-browser
  #itemBrowser
  [allowedTypes]="props.allowedTypes"
  [description]="props.description"
  [enableCreation]="props.enableCreation"
  [enableFullscreen]="props.enableFullscreen"
  [enableSelectFrozen]="props.enableSelectFrozen !== undefined ? props.enableSelectFrozen : true"
  [enableSummaryPopover]="false"
  [enableVariantSelection]="props.enableVariantSelection !== undefined ? props.enableVariantSelection : true"
  [excludeId]="props.excludeId"
  [hideOptionalMarker]="props.hideOptionalMarker"
  [id]="field.id"
  [label]="props.label"
  [layout]="props.layout || ItemBrowserLayout.HORIZONTAL"
  [multiple]="props.multiple"
  [parentComponentId]="props.componentId"
  [required]="props.required"
  [restrictToUserEquipment]="props.restrictToUserEquipment"
  [showItemTypeSelector]="props.showItemTypeSelector"
  [type]="props.itemType"
  [usageType]="props.usageType"
  [value]="value"
  (creationModeEnded)="onCreationModeEnded()"
  (creationModeStarted)="onCreationModeStarted()"
  (itemTypeChanged)="itemTypeChanged.emit($event)"
  (valueChanged)="onValueChanged($event)"
></astrobin-equipment-item-browser>

<ng-container *ngIf="props.quickAddRecentFromUserId">
  <div class="quick-add">
    <span class="quick-add-label">{{ "Quick-add recent" | translate }}:</span>

    <ng-container
      *ngIf="!recentLoaded; else recentLoadedTemplate"
      [ngTemplateOutlet]="loadingRecentTemplate"
    ></ng-container>

    <ng-template #recentLoadedTemplate>
      <ng-container *ngIf="recent.length > 0; else noRecentTemplate">
        <ng-container *ngFor="let item of recent">
          <a (click)="quickAddItem(item)" class="quick-add-item" astrobinEventPreventDefault href="#">
            <astrobin-equipment-item-display-name
              [enableSummaryPopover]="false"
              [item]="item"
            ></astrobin-equipment-item-display-name>
            <span
              (click)="openRemoveConfirmationModal($event, item)"
              class="remove-button"
              title="{{ 'Remove from recently used' | translate }}"
            >
              <fa-icon [icon]="['fas', 'times']"></fa-icon>
            </span>
          </a>
        </ng-container>
      </ng-container>
    </ng-template>
  </div>

  <div
    *ngIf="
      props.itemType === EquipmentItemType.TELESCOPE &&
      props.usageType === EquipmentItemUsageType.IMAGING &&
      recentLoaded &&
      recent.length === 0 &&
      formControl.value?.length === 0
    "
    class="no-recent alert alert-warning with-triangle"
  >
    {{ "Seems like it's your first time editing this kind of information!" | translate }}
    {{ "Start typing in the text box to show the dropdown suggestions." | translate }}
  </div>
</ng-container>

<ng-template #noRecentTemplate>
  <span *ngIf="!recentUsed" [innerHTML]="noRecentMessage" class="no-recent"></span>
  <span *ngIf="recentUsed" [innerHTML]="allRecentUsedMessage" class="no-recent"></span>
</ng-template>

<ng-template #loadingRecentTemplate>
  <astrobin-text-loading-indicator></astrobin-text-loading-indicator>
</ng-template>
